import { defineStore } from 'pinia';
import { getCustomInfo } from '@/common/services';
import { cookies } from '@bilibili/magic-bag';
import { track } from '@bilibili/magic-track';
import { CUSTOMER_TYPE } from '@/common/constant';
import { getMerchantAccountInfo } from '@/common/api/api';

const useCommonStore = defineStore('common', {
    state: () => ({
        merchantType: null,
        businessType: null,
        userInfo: {},
        customInfo: {},
        /** 商户账号信息 */
        merchantAccountInfo: {}
    }),
    actions: {
        setUserInfo(userInfo) {
            this.userInfo = userInfo;
            this.merchantType = userInfo?.merchants?.[0]?.merchantType || '';
            this.businessType = userInfo?.merchants?.[0]?.businessType || '';
        },
        setCustomInfo() {
            getCustomInfo().then((res) => {
                const { type, subType } = res;
                const customerType = type === 3 && subType === 31 ? 99 : type;
                const customerKey = CUSTOMER_TYPE.getKeyByValue(customerType);
                this.customInfo = {
                    ...res,
                    key: customerKey
                    // showChat: customerKey === 'ZI_YAN' || (customerKey === 'SI_XIN' && customerServiceUid === this.userInfo.uid)
                };
            });
        },
        // 设置默认的埋点配置
        setDefaultTrackConfig() {
            const merchantId = cookies.get('BILI-MALL-MERCHANT-ID');
            track.config({
                commonParams: {
                    merchantId,
                    merchantid: merchantId,
                    uid: this.userInfo.uid,
                    uname: this.userInfo.uname
                }
            });
        },
        /** 初始化商户账号信息 */
        async initMerchantAccountInfo() {
            try {
                const res = await getMerchantAccountInfo();
                if (res.code === 0) {
                    this.merchantAccountInfo = res.data || {};
                }
                return res;
            } catch (error) {
                console.error('获取商户账号信息失败:', error);
                throw error;
            }
        }
    },
    getters: {
        /** 是否绑定官方号 */
        isBindOfficialAccount() {
            // 官方账号
            const officialAccount = this.merchantAccountInfo?.officialAccount;
            // 官方账号存在
            return !!officialAccount;
        },
        /** 当前账号是否为官方账号 */
        currentAccountIsOfficialAccount() {
            // 官方账号
            const officialAccount = this.merchantAccountInfo?.officialAccount;
            // 当前账号
            const currentAccount = this.userInfo.uid;
            // 官方账号===当前账号
            return +officialAccount === +currentAccount;
        },
        /** 当前账号是否为主账号 */
        currentAccountIsMainAccount() {
            // 主账号
            const mainAccount = this.merchantAccountInfo?.mainAccount;
            // 当前账号
            const currentAccount = this.userInfo.uid;
            // 主账号===当前账号
            return +mainAccount === +currentAccount;
        },
        /** 当前账号是否为子账号 */
        currentAccountIsSubAccount() {
            // 子账号列表
            const subAccountList = this.merchantAccountInfo?.subAccountList || [];
            // 当前账号
            const currentAccount = this.userInfo.uid;
            // 子账号列表中是否存在当前账号
            return subAccountList.includes(+currentAccount);
        }
    }
});

export default useCommonStore;
